import { render, staticRenderFns } from "./ContactsAndText.vue?vue&type=template&id=32a0feb8"
import script from "./ContactsAndText.vue?vue&type=script&lang=js"
export * from "./ContactsAndText.vue?vue&type=script&lang=js"
import style0 from "./ContactsAndText.vue?vue&type=style&index=0&id=32a0feb8&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports